module.exports = __webpack_public_path__ + "img/fail-big.ddc70100.svg";